import { render, staticRenderFns } from "./AdminRQWorkers.vue?vue&type=template&id=4c842a77&scoped=true&"
import script from "./AdminRQWorkers.vue?vue&type=script&lang=js&"
export * from "./AdminRQWorkers.vue?vue&type=script&lang=js&"
import style0 from "./AdminRQWorkers.vue?vue&type=style&index=0&id=4c842a77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c842a77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c842a77')) {
      api.createRecord('4c842a77', component.options)
    } else {
      api.reload('4c842a77', component.options)
    }
    module.hot.accept("./AdminRQWorkers.vue?vue&type=template&id=4c842a77&scoped=true&", function () {
      api.rerender('4c842a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminRQWorkers.vue"
export default component.exports